"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
export default function TermsOverview() {
  // 保留滾動偵測機制
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section data-section-id="81834" id="knowledge-overview" className="w-full bg-[#f3ede5] pt-12 md:pt-16 pb-0 overflow-hidden">
      <div ref={ref} className={cn("w-full transition-all duration-[1200ms] ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4")}>
        
        {/* 全域大 Banner 容器：底色設定為與圖片底色相近的暖米色，確保兩側融合 */}
        <div className="relative w-full h-[220px] sm:h-[300px] md:h-[380px] lg:h-[450px] overflow-hidden bg-[#f0e7e0] border-none rounded-t-2xl md:rounded-t-[32px] block">
          
          {/* ==========================================
               背景圖層：使用 object-contain 顯示完整大圖
             ========================================== */}
          <img src="https://hent.services/wp-content/uploads/2026/05/Discovery_BG_bottom2-scaled.png" alt="Hent Flooring Showcase Background" className="absolute inset-0 block w-full h-full object-cover object-center border-none pointer-events-none z-0" />

  

          {/* 前景文字與按鈕控制層 */}
          <div className="absolute inset-0 z-10 select-none">
            <div className="container mx-auto px-8 sm:px-14 md:px-20 lg:px-24 w-full h-full relative">
              
              {/* 標題文字區 */}
              <div className="absolute top-[18%] md:top-[22%] left-8 sm:left-14 md:left-20 lg:left-24 flex flex-col items-start drop-shadow-[0_2px_6px_rgba(0,0,0,0.15)]">
                <h2 className="font-sans text-lg sm:text-xl md:text-2xl lg:text-3xl font-medium text-white tracking-widest leading-relaxed">
                  喜歡淺色
                </h2>
                <h2 className="font-sans text-lg sm:text-xl md:text-2xl lg:text-3xl font-medium text-white tracking-widest leading-relaxed">
                  還是深色耐看？
                </h2>
              </div>

              {/* 直角方塊按鈕組 */}
              <a href="/ProductsPage" className="group absolute bottom-[25px] left-8 sm:left-14 md:left-20 lg:left-24 inline-flex items-center gap-2 sm:gap-3 bg-[#544741] hover:bg-[#433833] text-white text-[10px] sm:text-xs md:text-sm font-sans tracking-widest px-4 py-2.5 sm:px-5 sm:py-3 md:px-6 md:py-3.5 rounded-none border-none shadow-[0_4px_12px_rgba(0,0,0,0.1)] transition-all duration-300 pointer-events-auto">
                找到適合你的地板
                <ArrowRight className="size-3.5 md:size-4 transition-transform group-hover:translate-x-1" />
              </a>

            </div>
          </div>

        </div>

      </div>
    </section>;
}